import { DrLicitaTypes } from './types';

export const getDocuments = () => ({
  types: [
    DrLicitaTypes.GET_DOCUMENTS_REQUEST,
    DrLicitaTypes.GET_DOCUMENTS_SUCCESS,
    DrLicitaTypes.GET_DOCUMENTS_FAILURE,
  ],
  promise: (client: any) => client.get('/dr_licita/documents'),
});

export const getDocumentTypes = () => ({
  types: [
    DrLicitaTypes.GET_DOCUMENT_TYPES_REQUEST,
    DrLicitaTypes.GET_DOCUMENT_TYPES_SUCCESS,
    DrLicitaTypes.GET_DOCUMENT_TYPES_FAILURE,
  ],
  promise: (client: any) => client.get('/dr_licita/documents_types'),
});

export const getLawTypes = () => ({
  types: [
    DrLicitaTypes.GET_LAW_TYPES_REQUEST,
    DrLicitaTypes.GET_LAW_TYPES_SUCCESS,
    DrLicitaTypes.GET_LAW_TYPES_FAILURE,
  ],
  promise: (client: any) => client.get('/dr_licita/laws_types'),
});

export const destroyDocument = (documentId: number) => {
  return {
    types: [
      DrLicitaTypes.DELETE_DOCUMENT_REQUEST,
      DrLicitaTypes.DELETE_DOCUMENT_SUCCESS,
      DrLicitaTypes.DELETE_DOCUMENT_FAILURE,
    ],
    documentId,
    promise: (client: any) => client.delete(`/dr_licita/documents/${documentId}`),
  };
};
